/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiButtonEmpty } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { FunctionComponent } from 'react'

const MenuButton: FunctionComponent<{
  billingYears?: number[]
  selectedYear?: number
  onClick: () => void
}> = ({ billingYears, selectedYear, onClick }) => {
  const displayYear = billingYears?.length === 1 ? billingYears[0] : selectedYear

  return (
    <EuiButtonEmpty size='xs' color='text' iconType='arrowDown' iconSide='right' onClick={onClick}>
      <FormattedMessage
        id='billing-table-pagination.button-label'
        defaultMessage='Billing year: {selectedYear}'
        values={{
          selectedYear: displayYear || (
            <FormattedMessage
              id='billing-table-pagination.selected-year.all'
              defaultMessage='All'
            />
          ),
        }}
      />
    </EuiButtonEmpty>
  )
}

export default MenuButton
